export const copy = (textToCopy: string) => {
  return navigator.clipboard.writeText(textToCopy);
};
